// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1avNG","large":"styles_large__2GxXm"};